export const BOWTIE_PINK = '#FF0068';
export const BOWTIE_BLUE = '#191357';
export const INK = '#2A2E42';
export const GRAPHITE = '#687188';
export const DRAGON_FRUIT = '#DF005B';
export const BUBBLE_GUM = '#FFBFD9';
export const BLUSH = '#FFF0F6';
export const INDIGO = '#130E41';
export const LILAC = '#D7DFFF';
export const SMURF = '#426CE2';
export const ROCK = '#C2C6D1';
export const STONE = '#EBECF0';
export const PEBBLE = '#F6F6F9';
export const WHITE = '#FFFFFF';
export const HOTEL_CALIFORNIA = '#f05f00';
export const GREEN_DAY = '#0bc28d';
export const YELLOW_SUBMARINE = '#FFAA00';
export const INK_50 = 'rgba(42, 46, 66, 0.5)';
export const INK_20 = 'rgba(42, 46, 66, 0.2)';
export const INK_10 = 'rgba(42, 46, 66, 0.1)';
export const GRAPHITE_50 = 'rgba(104, 113, 136, 0.5)';
export const GRAPHITE_20 = 'rgba(104, 113, 136, 0.2)';
export const GRAPHITE_10 = 'rgba(104, 113, 136, 0.1)';
export const GREEN_DAY_50 = 'rgba(11, 194, 141, 0.5)';
export const GREEN_DAY_20 = 'rgba(11, 194, 141, 0.2)';
export const GREEN_DAY_10 = 'rgba(11, 194, 141, 0.1)';